import React from 'react';
import {Flex, Image} from "antd";
import {clrs} from "../../../constants/colors";
import back from './BG.png';
import classes from '../home.module.css';
import banner from './image.png';
import MyText from "../../../components/UI/Text/MyText";
import IntlMessage from "../../../components/IntlMessage/IntlMessage";
import GreenLightButton from "../../../components/UI/Buttons/GreenLightButton";
import {Link} from "react-router-dom";

const Banner = () => {
    return (
        <Flex style={{width: "100%", position: "relative", padding: "120px 20px 20px 20px", backgroundColor: clrs.blue}} align={"center"} justify={"center"}>
            <Flex gap={50}
                  style={{width: "100%", maxWidth: 1440, position: "relative", height: 550, overflow: "hidden"}}
                  align={"center"} justify={"flex-start"}>
                <img src={back} alt="" className={classes.bannerBack}/>
                <Flex>
                    <Image preview={false} src={banner} width={300}/>
                </Flex>
                <Flex align={"flex-start"} justify={"flex-start"} vertical gap={25} style={{zIndex: 100}}>
                    <MyText style={{fontSize: "4rem", fontWeight: 800, color: "white"}}>
                        <IntlMessage id={'homePage.banner.head'}/>
                    </MyText>
                    <MyText style={{fontSize: "1.5rem", fontWeight: 500, color: "white"}}>
                        <IntlMessage id={'homePage.banner.body'}/>
                    </MyText>
                    <Link to={'/login'}>
                        <GreenLightButton style={{fontSize: "1rem"}}>
                            <IntlMessage id={'homePage.monitoring'}/>
                        </GreenLightButton>
                    </Link>
                </Flex>
            </Flex>
        </Flex>
    );
};

export default Banner;